import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../context/AuthContext";
import { setAuthSession } from "../../utils/authStorage";

const OAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { fetchMe } = useAuth();

  useEffect(() => {
    const processOAuthCallback = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const accessToken = params.get("accessToken");
        const refreshToken = params.get("refreshToken");
        const requiresVerification =
          params.get("requiresVerification") === "true";
        const requires2FA = params.get("requires2FA") === "true";
        const email = params.get("email");
        const error = params.get("error");

        if (error) {
          throw new Error(error);
        }

        // If 2FA is required, redirect to 2FA login page
        if (requires2FA) {
          navigate("/login/2fa", { state: { email }, replace: true });
          return;
        }

        // If one-time verification is required, redirect to OTP page
        if (requiresVerification) {
          const targetPath = email ? `/verify-otp/${email}` : "/verify-otp";
          navigate(targetPath, { state: { isFirstTime: true }, replace: true });
          return;
        }

        if (!accessToken || !refreshToken) {
          throw new Error("Authentication failed: Missing tokens");
        }

        // Store tokens in local storage
        setAuthSession({ accessToken, refreshToken });

        // Update auth context
        await fetchMe();

        // Redirect to home or previous page
        const from = location.state?.from?.pathname || "/";
        navigate(from, { replace: true });

        toast.success("Successfully signed in with Google!");
      } catch (error) {
        console.error("OAuth callback error:", error);
        toast.error(error.message || "Failed to sign in with Google");
        navigate("/login", { replace: true });
      }
    };
    processOAuthCallback();
  }, [location, navigate, fetchMe]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500 mx-auto mb-4"></div>
        <p className="text-white text-lg">Completing sign in...</p>
      </div>
    </div>
  );
};

export default OAuthCallback;
